import React from 'react';
import classNames from 'classnames/bind';

import { formatROILabel } from '../services/format_label';
import { PADDING } from './Label';
import { ROI_CONFIG } from '../config';
import styles from '../ROICanvas.module.scss';

const c = classNames.bind(styles);

export type ROILabelInputProps = {
  x: number;
  y: number;
  offsetX: number;
  offsetY: number;
  rotation: number;
  defaultValue: string;
  onValidate: (text: string) => boolean;
  onSave: (text: string) => void;
  onCancel: () => void;
};

export function ROILabelInput({
  x,
  y,
  offsetX,
  offsetY,
  rotation,
  defaultValue,
  onValidate,
  onSave,
  onCancel,
}: ROILabelInputProps) {
  const [hasError, setHasError] = React.useState(false);

  function handleChange() {
    setHasError(false);
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    switch (event.key) {
      case 'Escape': {
        onCancel();
        setHasError(false);
        break;
      }

      case 'Enter': {
        if (onValidate(event.currentTarget.value)) {
          onSave(formatROILabel(event.currentTarget.value));
          break;
        }

        setHasError(true);
        break;
      }
    }
  }

  function handleBlur(event: React.FocusEvent<HTMLInputElement>) {
    event.stopPropagation();
    event.preventDefault();

    if (onValidate(event.currentTarget.value)) {
      onSave(formatROILabel(event.currentTarget.value));
      return;
    }

    setHasError(true);
  }

  return (
    <input
      className={c('input', { error: hasError })}
      defaultValue={defaultValue}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      style={
        {
          color: ROI_CONFIG.labelText.fill,
          fontSize: ROI_CONFIG.labelText.fontSize,
          backgroundColor: ROI_CONFIG.labelBg.fill,
          borderRadius: ROI_CONFIG.labelBg.cornerRadius,
          padding: PADDING,
          position: 'absolute',
          top: y,
          left: x,
          transformOrigin: '0 0',
          '--rotation': `${rotation}deg`,
          '--offsetX': `${-offsetX}px`,
          '--offsetY': `${-offsetY}px`,
        } as React.CSSProperties
      }
      autoFocus
    />
  );
}
